@if (contentToCopy) {
<a #copyBtn class="copy-btn" (click)="copyTextToClipboard()">
  {{ copyText }}
</a>
}
